import { INameValue } from "src/shared/types/common.types";
import { EIconNames } from "src/shared/types/iconNames";
import { ColumnKey, CooperationValue } from "./types";

export const COLUMNS: { key: ColumnKey; label: string }[] = [
  { key: "recommendations", label: "Рекомендации" },
  { key: "advisor", label: "Советник" },
  { key: "reportlab", label: "ReportLab" },
  { key: "utm_helper", label: "UTM Помощник" },
  { key: "streams", label: "Потоки" },
  { key: "automation_center", label: "Центр Автоматизации" },
];

export const SERVICE_ROWS: Record<
  string,
  { id: string; name: string; logo: EIconNames }
> = {
  google: { id: "google", name: "Google Ads", logo: EIconNames.GOOGLE_ADS_ST },
  fb: { id: "fb", name: "Meta", logo: EIconNames.META_ST },
  tiktok: { id: "tiktok", name: "TikTok", logo: EIconNames.TIKTOK_ST },
  yandex: {
    id: "yandex",
    name: "Yandex Direct",
    logo: EIconNames.YANDEX_DIRECT_ST,
  },
  vkads: { id: "vkads", name: "VK Реклама", logo: EIconNames.VK_ADS_ST },
};

export const TOOL_TO_COLUMN: Record<string, ColumnKey> = {
  recommendations: "recommendations",
  adviser: "advisor",
  reportlab: "reportlab",
  utm_assistant: "utm_helper",
  adflow: "streams",
  automation_center: "automation_center",
};

export const partnershipTypeOptions: Array<INameValue<CooperationValue>> = [
  { name: "Наше ведение", value: "our_management" },
  { name: "Самоуправление", value: "self-rule" },
];
